module.exports = __webpack_public_path__ + "img/motor_no57.2af5fce8.jpg";